/**
 * s3 upload related methods are kept here
 */

import axios, { baseRequestConfig } from './base';

// get presigned url and meta data for s3 uplaod
export function getUploadUrl(userToken, key, hidden) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'dataobj_get_upload_url',
        values: {
          key,
          private: hidden,
        },
      },
    },
  });
}

// confirm the s3 upload to the backend
export function confirmUpload(userToken, values, hidden) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'dataobj_confirm_upload',
        values: {
          ...values,
          private: hidden,
        },
      },
    },
  });
}

export function addMediaUrl(userToken, dataUrl, taskId) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'dataobj_confirm_upload',
        values: {
          task_id: taskId,
          data_url: dataUrl,
        },
      },
    },
  });
}

export function addProjectMediaUrl(userToken, dataUrl, projectId) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'dataobj_confirm_upload',
        values: {
          project_id: projectId,
          data_url: dataUrl,
        },
      },
    },
  });
}
// removes the media object
export function removeMedia(userToken, values) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'dataobj_rem_obj',
        values,
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/api/medias.js